// extracted by mini-css-extract-plugin
module.exports = {"root":"DefaultLayout_root__3t7Ps","content":"DefaultLayout_content__28ZwA","footer":"DefaultLayout_footer__2SIzp"};